import { module } from 'modujs'

export default class extends module {
  play() {
    /* global Odometer */
    this.odometer = new Odometer({
      el: this.el,
      value: '00',
      theme: 'minimal',
      format: 'd',
      duration: 800
    })

    this.odometer.render()

    this.el.textContent = this.el.getAttribute('data-value')
  }

  destroy() {
    this.odometer.stopWatchingMutations()
    this.odometer.resetDigits()
  }
}
